export default {
    scrollbar: null,
    scripts: [],
    scrollbarHeaderInit: function () {
        var flagScrollTargetOffset = $(window).scrollTop() + window.innerHeight;

        $('.animate:not(.animated)').each(function () {
            var flag = $(this).offset().top;
            if (flag < flagScrollTargetOffset) {
                $(this).addClass('animated');
                $(this).removeClass('h-animate');
            }
        });
    },
    scrollbarEvent: function (e) {
        if( $("body").hasClass("menu-open")){
            e.preventDefault();
            return false;
        }

        var flagScrollTargetOffset = $(window).scrollTop() + window.innerHeight;


        if($(window).scrollTop() > 0){
            $("body").addClass("header-fix");
        }else{
            $("body").removeClass("header-fix");
        }

        $('.animate:not(.animated)').each(function () {
            var flag = $(this).offset().top;
            //console.log(flag, flagScrollTargetOffset, flag < flagScrollTargetOffset);
            if (flag < flagScrollTargetOffset) {
                $(this).addClass('animated');
                $(this).removeClass('h-animate');
            }
        });

        $('.delaySection:not(.showSection)').each(function () {
            var flag = $(this).offset().top;

            //console.log(flag, flagScrollTargetOffset, flag < flagScrollTargetOffset);
            if (flag < flagScrollTargetOffset)
                $(this).addClass('showSection');

            $(this).find("select.select2").select2({
                minimumResultsForSearch: 'Infinity',
            });
        });

        $('footer.delaySection:not(.showSection)').each(function () {
            var flag = $(this).offset().top;

            //console.log(flag, flagScrollTargetOffset, flag < flagScrollTargetOffset);
            if (flag - 80 < flagScrollTargetOffset)
                $(this).addClass('showSection');

        });
    },
}




// WEBPACK FOOTER //
// ./scripts/functions.js